import { gql } from '@apollo/client';

export const EXTERNAL_COMPANIES_QUERY = gql`
  query getRegionsQuery($group_id: String, $company_id: String) {
    external_companies(group_id: $group_id, company_id: $company_id) {
      id
      active
      name
      created
      modified
      deleted
      scope
    }
  }
`;
